import $ from 'jquery';
import breakpoints from './breakpoints';

function title(str) {
  return str.charAt(0).toUpperCase() + str.substring(1);
}

function setSource(node, srcType) {
  const $map = $(node);
  const src = $map.data(`src${title(srcType)}`);

  $map.attr({ src });
}

function testMQ($maps) {
  if (breakpoints.min.bg.matches) {
    $maps.each((i, el) => { setSource(el, 'desktop'); });
  } else {
    $maps.each((i, el) => { setSource(el, 'mobile'); });
  }
}

export default () => {
  const $maps = $('iframe.responsive-map');

  if (breakpoints.min.bg.matches) {
    testMQ($maps);
  }

  breakpoints.min.bg.addListener(() => { testMQ($maps) });
}
